var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('result-card',{attrs:{"question":_vm.question,"status":"correct"}},[_c('template',{slot:"score-icon"},[_c('check-icon',{attrs:{"fillColor":"#08db88"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }